<template>
  <div class="controls">
    <div class="controls-top">
      <RecordIndicator />
    </div>
    <div
      v-click-outside="onClickOutsideControls"
      class="controls-bottom"
      :class="{
        show:
          (!isFullScreen || !controlsInvisibleInFullScreen) &&
          showBottomControls,
        ios15,
      }"
    >
      <template>
        <button
          v-if="microphoneDisabled"
          class="controls-btn controls-btn_mic-off"
          @click="toggleMicrophone"
        >
          <span class="controls-btn__tooltip">{{ $t('onMic') }}</span>
        </button>
        <button
          v-else
          class="controls-btn controls-btn_mic"
          @click="toggleMicrophone"
        >
          <span class="controls-btn__tooltip">{{ $t('offMic') }}</span>
        </button>
      </template>
      <template v-if="cameras.length && cameras[0].deviceId">
        <button
          v-if="cameraDisabled"
          class="controls-btn controls-btn_cam-off"
          @click="toggleCamera"
        >
          <span class="controls-btn__tooltip">{{ $t('onVideo') }}</span>
        </button>
        <button
          v-else
          class="controls-btn controls-btn_cam"
          @click="toggleCamera"
        >
          <span class="controls-btn__tooltip">{{ $t('offVideo') }}</span>
        </button>
      </template>
      <template>
        <button
          v-if="!captured"
          class="controls-btn controls-btn_screen"
          @click="startCapture()"
        >
          <!--          {{ captured ? 'Остановить демонстрацию' : 'Демонстрация экрана' }}-->
          <span class="controls-btn__tooltip">{{ $t('onDemo') }}</span>
        </button>
        <button
          v-else
          class="controls-btn controls-btn_screen-off"
          @click="startCapture(false)"
        >
          <span class="controls-btn__tooltip">{{ $t('offDemo') }}</span>
        </button>
      </template>
      <template v-if="user.isAdmin.value">
        <div>
          <div
            v-if="showRecordBubble && !recordingRoom"
            class="controls-btn__popup controls-btn__popup_record"
          >
            <span>
              {{ $t('youCanRecordThisMeeting') }}
            </span>
            <button
              class="controls-btn__popup-btn controls-btn__popup-btn_close"
              @click="closeRecordBubble"
            />
          </div>
          <button
            v-if="!recordingRoom"
            class="controls-btn controls-btn_record"
            @click="handleStartRecordBtn"
          >
            <span class="controls-btn__tooltip">{{ $t('onRecord') }}</span>
          </button>
          <button
            v-else
            class="controls-btn controls-btn_record-off"
            @click="handleStopRecordBtn"
          >
            <span class="controls-btn__tooltip">{{ $t('offRecord') }}</span>
          </button>
        </div>
      </template>
      <VideoRoomSettings class="d-none" />
      <button v-if="showMoreBtn" class="controls-btn controls-btn_more" @click="showMore = !showMore" />
      <div>
        <button class="controls-btn controls-btn_exit" @click="exit = !exit">
          <span class="controls-btn__tooltip">{{ $t('endCall') }}</span>
        </button>
      </div>
    </div>
    <div v-if="showMore" v-click-outside="onClickOutside" class="more-window">
      <div class="more-window__item more-window__item_fullscreen">
        <button v-if="!isFullScreen" class="more-window__btn more-window__btn_screen-all"
                @click="toggleFullScreen()"
        >
          {{ $t('onFullScreen') }}
        </button>
        <button v-else class="more-window__btn more-window__btn_screen-all-off"
                @click="toggleFullScreen()"
        >
          {{ $t('offFullScreen') }}
        </button>
      </div>
      <div v-if="user.isAdmin.value" class="more-window__item">
        <button class="more-window__btn more-window__btn_candidate" @click="toggleInvite('candidate')">
          {{ $t('inviteCandidate') }}
        </button>
      </div>
      <div v-if="user.isAdmin.value" class="more-window__item">
        <button class="more-window__btn more-window__btn_colleague" @click="toggleInvite()">
          {{ $t('inviteColleague') }}
        </button>
      </div>
      <VideoRoomControlsInvite v-if="invite" :invite="invite" @close="invite = null" />
      <div class="more-window__close" @click="showMore = false" />
    </div>
    <div v-if="exit" class="exit-window">
      <div class="exit-window__wrap">
        <p class="exit-window__text">
          {{ user.isAdmin.value ? $t('endCallMessage') : $t('leaveCallMessage') }}
        </p>
        <div class="exit-window__actions">
          <template v-if="user.isAdmin.value">
            <button class="exit-window__btn exit-window__btn_red" @click="stopRoom">
              {{ $t('endCallForAll') }}
            </button>
            <button class="exit-window__btn exit-window__btn_secondary" @click="exitFrom">
              {{ $t('leaveCall') }}
            </button>
          </template>
          <template v-else>
            <button class="exit-window__btn exit-window__btn_red" @click="exitFrom">
              {{ $t('yes') }}
            </button>
            <button class="exit-window__btn exit-window__btn_secondary" @click="exit = false">
              {{ $t('cancel') }}
            </button>
          </template>
        </div>
        <button class="exit-window__close" @click="exit = false" />
      </div>
    </div>
  </div>
</template>

<script>
import useJanusPublisher from '@/compositions/useJanusPublisher';
import useCaptureScreen from '@/compositions/useCaptureScreen';
import useCamera from '@/compositions/useCamera';
import useMicrophone from '@/compositions/useMicrophone';
import useFullScreen from '@/compositions/useFullScreen';
import useRoom from '@/compositions/useRoom';
import useHomeUrl from '@/compositions/useHomeUrl';
import RecordIndicator from '@/components/RecordIndicator.vue';
import useStreams from '@/compositions/useStreams';
import VideoRoomSettings from '@/components/VideoRoomSettings.vue';
import { computed, onMounted, ref } from '@vue/composition-api';
import VideoRoomControlsInvite from '@/components/VideoRoomControlsInvite.vue';
import useVideo from '@/compositions/useVideo';
import useConnections from '@/compositions/useConnections';

export default {
  name: 'JanusStreamControl',
  components: {
    VideoRoomControlsInvite,
    VideoRoomSettings,
    RecordIndicator,
  },
  setup(_, { root }) {
    const {
      published,
      startPublish,
      processRecord,
      stopActivityUpdate,
    } = useJanusPublisher();
    const {
      user,
      closeRoom,
      existRoom,
      recordingRoom,
      invitations,
      leftRoom,
    } = useRoom();
    const { homeUrl } = useHomeUrl();
    const showBottomControls = ref(true);
    const { startCapture, captured } = useCaptureScreen();
    const { toggleCamera, cameras } = useCamera();
    const { cameraDisabled, microphoneDisabled } = useStreams();
    const exit = ref(false);

    const { toggleMicrophone } = useMicrophone();
    const { toggleVideo, isVideoDisabled } = useConnections();

    const showMore = ref(false);
    const invite = ref(null);

    const { requestFullScreen, isFullScreen, exitFullScreen } = useFullScreen();

    function stopRoom() {
      stopActivityUpdate();
      closeRoom();
    }

    function toggleFullScreen() {
      return isFullScreen.value ? exitFullScreen() : requestFullScreen();
    }

    function isTouchDevice() {
      return window.ontouchstart !== undefined;
    }

    function toggleInvite(type) {
      if (type === 'candidate') {
        invite.value = {
          title: root.$t('inviteCandidateTitle'),
          link: `${homeUrl}${invitations.value.candidate}`,
        };
      } else {
        invite.value = {
          title: root.$t('inviteColleagueTitle'),
          link: `${homeUrl}${invitations.value.admin}`,
        };
      }
    }

    const showMoreBtn = computed(() => user.isAdmin.value || window.innerWidth >= 960);

    function onClickOutsideControls() {
      if (!isTouchDevice()) {
        return;
      }

      showBottomControls.value = !showBottomControls.value;
    }

    const controlsInvisibleInFullScreen = ref(true);
    const handleMainVideoClick = () => {
      controlsInvisibleInFullScreen.value = !controlsInvisibleInFullScreen.value;
    };

    document.addEventListener('main-video-click', handleMainVideoClick);

    const showRecordBubble = localStorage.getItem('RecordPopupIsShown')
      ? ref(false)
      : ref(true);

    setTimeout(() => {
      showRecordBubble.value = false;
      localStorage.setItem('RecordPopupIsShown', true);
    }, 10 * 1000);

    function closeRecordBubble() {
      showRecordBubble.value = false;
      localStorage.setItem('RecordPopupIsShown', true);
    }

    const handleStartRecordBtn = () => {
      processRecord(true);
      closeRecordBubble();
    };

    const handleStopRecordBtn = () => {
      processRecord(false);
    };

    function muteVideo(state) {
      toggleVideo(state);
    }

    return {
      published,
      startPublish,
      processRecord,
      startCapture,
      handleStopRecordBtn,
      handleStartRecordBtn,
      toggleCamera,
      cameraDisabled,
      toggleMicrophone,
      microphoneDisabled,
      requestFullScreen,
      user,
      closeRoom,
      captured,
      stopRoom,
      recordingRoom,
      isFullScreen,
      exitFullScreen,
      toggleFullScreen,
      exit,
      exitFrom: () => {
        leftRoom.value = true;
      },
      showBottomControls,
      showMore,
      onClickOutside() {
        showMore.value = false;
      },
      toggleInvite,
      invite,
      onClickOutsideControls,
      showMoreBtn,
      ios15: navigator.userAgent.indexOf('iPhone OS 15') !== -1,
      cameras,
      controlsInvisibleInFullScreen,
      showRecordBubble,
      closeRecordBubble,
      isVideoDisabled,
      muteVideo,
    };
  },
};
</script>

<style lang="scss" scoped>
.controls-top {
  display: flex;
  position: absolute;
  top: 1.875rem;
  left: 1.875rem;
}

.controls-bottom {
  display: none;
  justify-content: center;
  align-items: center;
  position: absolute;
  bottom: 1rem;
  left: 50%;
  transform: translateX(-50%);
  width: fit-content;
  background: rgba(80, 80, 86, 0.75);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border-radius: 2rem;
  padding: 0.5rem 0.75rem;
  gap: 0.25rem;

  > div:not(.more-window) {
    position: relative;
    display: flex;
    align-items: center;
  }
  &.ios15 {
    bottom: 90px;
  }
  &.show {
    display: flex;
  }
}

.controls-btn {
  width: 2.75rem;
  height: 2.75rem;
  background: transparent no-repeat center;
  border: none;
  color: #949494;
  transition: filter ease-out 0.2s, background-color 0.2s;
  margin: 0;
  padding: 0;
  border-radius: 50%;
  position: relative;
  &:focus, &:active, &:hover {
    filter: brightness(1.25);
    outline: none;
    background-color: rgba(255, 255, 255, 0.08);
  }
  &:hover {
    .controls-btn__tooltip {
      visibility: visible;
      opacity: 1;
    }
  }
  &__tooltip {
    width: max-content;
    visibility: hidden;
    background: rgba(28, 28, 30, 0.95);
    padding: 0.25rem 0.625rem;
    border-radius: 6px;
    font-size: 0.75rem;
    line-height: 1.6;
    color: #FFFFFF;
    position: absolute;
    z-index: 5;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    &:after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -4px;
      border-width: 4px;
      border-style: solid;
      border-color: rgba(28, 28, 30, 0.95) transparent transparent transparent;
    }
  }
  &_mic {
    background-image: url('../assets/img/icons/microphone.svg');
  }
  &_mic-off {
    background-image: url('../assets/img/icons/microphone-off.svg');
  }
  &_cam {
    background-image: url('../assets/img/icons/camera.svg');
  }
  &_cam-off {
    background-image: url('../assets/img/icons/camera-off.svg');
  }
  &_screen {
    background-image: url('../assets/img/icons/screen.svg');
  }
  &_screen-off {
    background-image: url('../assets/img/icons/screen-off.svg');
  }
  &_record {
    background-image: url('../assets/img/icons/record.svg');
  }
  &_record-off {
    background-image: url('../assets/img/icons/record-off2.svg');
  }
  &_more {
    background-image: url('../assets/img/icons/more.svg');
  }
  &_exit {
    width: 2.75rem;
    background-image: url("../assets/img/icons/exit.svg");
    background-color: #FF3B30;
    border-radius: 50%;
    &:focus, &:active, &:hover {
      background-color: #E02020;
      filter: none;
    }
  }
  &__popup {
    position: absolute;
    bottom: calc(100% + 10px);
    left: 50%;
    transform: translateX(-50%);
    background: rgba(44, 44, 46, 0.96);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    color: rgba(255, 255, 255, 0.88);
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.45;
    border-radius: 0.625rem;
    max-width: 16rem;
    white-space: nowrap;
    padding: 0.5rem 2rem 0.5rem 0.875rem;
    text-align: center;

    &-btn {
      padding: 0;
      border: none;
      background: transparent;
      cursor: pointer;
      &_close {
        position: absolute;
        width: 1.25rem;
        height: 1.25rem;
        top: 0.375rem;
        right: 0.375rem;
        background: rgba(255, 255, 255, 0.1);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: background-color 0.15s;
        font-size: 0.875rem;
        line-height: 1;
        color: rgba(255, 255, 255, 0.65);
        &::before {
          content: '×';
        }
        &:hover {
          background: rgba(255, 255, 255, 0.18);
        }
      }
    }

    &_record {
      &:after {
        content: '';
        position: absolute;
        left: 50%;
        bottom: -5px;
        width: 10px;
        height: 10px;
        transform: translateX(-50%) rotate(45deg);
        background: rgba(44, 44, 46, 0.96);
        border-right: 1px solid rgba(255, 255, 255, 0.1);
        border-bottom: 1px solid rgba(255, 255, 255, 0.1);
      }
    }
  }
}

.more-window {
  width: 13.5rem;
  padding: 0.375rem;
  background: rgba(38, 38, 40, 0.97);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 0.875rem;
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  text-align: left;
  position: fixed;
  bottom: 5rem;
  left: 50%;
  transform: translateX(-50%);
  z-index: 4;

  &__item {
    & + & {
      border-top: 1px solid rgba(255, 255, 255, 0.05);
    }
  }

  &__btn {
    border: none;
    outline: none;
    font-size: 0.8125rem;
    line-height: 1.4;
    color: rgba(255, 255, 255, 0.82);
    padding: 0.625rem 0.625rem 0.625rem 2.25rem;
    background: transparent no-repeat center left 0.625rem;
    background-size: 1rem 1rem;
    border-radius: 0.5rem;
    width: 100%;
    text-align: left;
    cursor: pointer;
    transition: background-color 0.15s;

    &:hover, &:active, &:focus {
      border: none;
      outline: none;
      background-color: rgba(255, 255, 255, 0.07);
    }
    &_screen-all {
      background-image: url('../assets/img/icons/screen-all.svg');
    }
    &_screen-all-off {
      background-image: url('../assets/img/icons/screen-all-off.svg');
    }
    &_candidate {
      background-image: url('../assets/img/icons/invite-candidate.svg');
    }
    &_colleague {
      background-image: url('../assets/img/icons/invite-colleague.svg');
    }
    &_cam {
      background-image: url('../assets/img/icons/cam.svg');
    }
    &_cam-off {
      background-image: url('../assets/img/icons/cam-off.svg');
      padding: 1px 24px;
      background-size: 18px;
    }
  }

  &__close {
    display: none;
  }
}

.exit-window {
  &:before {
    content: '';
    position: fixed;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(6px);
    -webkit-backdrop-filter: blur(6px);
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 5;
  }

  &__wrap {
    width: 26rem;
    max-width: calc(100vw - 2rem);
    padding: 1.75rem 1.5rem 1.5rem;
    background: #FFFFFF;
    border-radius: 0.875rem;
    box-shadow: 0 12px 48px rgba(0, 0, 0, 0.22), 0 2px 8px rgba(0, 0, 0, 0.1);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 6;
  }

  &__text {
    font-size: 1rem;
    font-weight: 600;
    line-height: 1.35;
    color: #111111;
    margin: 0 0 1.375rem;
    padding-right: 1.75rem;
  }

  &__actions {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  &__btn {
    width: 100%;
    padding: 0.75rem 1.25rem;
    font-size: 0.9375rem;
    font-weight: 500;
    color: #FFFFFF;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: filter 0.15s, transform 0.12s;

    &_red {
      background: #FF3B30;
    }

    &_secondary {
      background: transparent;
      color: #3C3C43;
      border: 1px solid rgba(60, 60, 67, 0.18);

      &:hover {
        background: rgba(0, 0, 0, 0.04);
      }
    }

    &:focus {
      outline: none;
    }

    &:hover {
      filter: brightness(1.07);
    }

    &:active {
      transform: scale(0.98);
    }
    &_close {
      margin-right: 0.625rem;
    }
  }

  &__close {
    width: 1.75rem;
    height: 1.75rem;
    background: rgba(0, 0, 0, 0.06) url("../assets/img/icons/close.svg") no-repeat center;
    background-size: 10px;
    border-radius: 50%;
    border: none;
    position: absolute;
    top: 1rem;
    right: 1rem;
    cursor: pointer;
    transition: background-color 0.15s;

    &:focus {
      outline: none;
    }

    &:hover {
      background-color: rgba(0, 0, 0, 0.11);
    }
  }
}

@media (max-width: 1199px) {
  .controls-top {
    top: 0.875rem;
    left: 3.5rem;
  }
  .controls-btn {
    &_screen,
    &_screen-off,
    &_screen-all,
    &_screen-all-off,
    &__tooltip {
      display: none;
    }
  }
}

@media (max-width: 959px) {
  .controls-top {
    top: 1.375rem;
    left: 4rem;
  }
}

@media only screen and (orientation: landscape) and (max-width: 959px),
  only screen and (orientation: portrait) and (max-width: 959px) {
  .controls-top {
    top: 0.5rem;
    left: 3rem;
  }
  .controls-bottom {
    display: none;
    &.show {
      display: flex;
    }
  }
  .more-window__item_fullscreen {
    display: none;
  }
}

@media (max-width: 377px) {
  .controls-bottom {
    padding: 0 1rem;
  }
  .controls-btn {
    width: 2.5rem;
    height: 2.5rem;
    background-size: contain;
    &_exit {
      width: 3.125rem;
    }
  }
}
</style>

<i18n locale="en" lang="yaml">
onMic: Turn on the microphone
offMic: Turn off the microphone
onVideo: Enable video
offVideo: Stop video
onDemo: Screen demonstration
offDemo: Stop Demo
onRecord: Record a meeting
offRecord: Stop Recording
onFullScreen: Full screen mode
offFullScreen: Collapse
inviteCandidate: Invite a candidate
inviteColleague: Invite a colleague
endCall: End call
endCallMessage: End this meeting for everyone?
leaveCallMessage: Leave the meeting?
endCallForAll: End for everyone
leaveCall: Leave the meeting
yes: Yes
cancel: Cancel
inviteCandidateTitle: Invite a candidate
inviteColleagueTitle: Invite a colleague
youCanRecordThisMeeting: You can record this meeting
muteCameras: Switch-off video
unmuteCameras: Switch-on video
</i18n>

<i18n locale="ru" lang="yaml">
onMic: Включить микрофон
offMic: Выключить микрофон
onVideo: Включить видео
offVideo: Остановить видео
onDemo: Демонстрация экрана
offDemo: Остановить демонстрацию
onRecord: Записать встречу
offRecord: Остановить запись
onFullScreen: Полноэкранный режим
offFullScreen: Свернуть
inviteCandidate: Пригласить кандидата
inviteColleague: Пригласить коллегу
endCall: Завершить звонок
endCallMessage: Завершить эту встречу для всех?
leaveCallMessage: Покинуть встречу?
endCallForAll: Завершить для всех
leaveCall: Покинуть встречу
yes: Да
cancel: Отмена
inviteCandidateTitle: Пригласите кандидата
inviteColleagueTitle: Пригласите коллегу
youCanRecordThisMeeting: Вы можете записать эту встречу
muteCameras: Отключить видео
unmuteCameras: Включить видео
</i18n>
